/**
 * Supported languages
 */
export enum I18nLanguage {
	DE = 'de',
	EN = 'en',
	FR = 'fr',
	JA = 'ja',
}

// TODO: this is related to how these are referenced in the locales sheet
/**
 * Supported locales as directly referenced in the locales sheet
 */
export enum I18nSupportedLocale {
	ENGLISH = 'en-US',
	FRENCH = 'fr-FR',
	GERMAN = 'de-DE',
	JAPANESE = 'ja-JP',
}

/**
 * A map of language to its aliases
 */
export const I18N_LANGUAGE_ALIASES: Record<I18nLanguage, string[]> = {
	[I18nLanguage.DE]: [I18nSupportedLocale.GERMAN, I18nLanguage.DE],
	[I18nLanguage.EN]: [I18nSupportedLocale.ENGLISH, I18nLanguage.EN],
	[I18nLanguage.FR]: [I18nSupportedLocale.FRENCH, I18nLanguage.FR, 'fr-CA'],
	[I18nLanguage.JA]: [I18nSupportedLocale.JAPANESE, I18nLanguage.JA, 'jp-JP'],
};

/**
 * A list of all supported languages
 */
export const I18N_SUPPORTED_LANGUAGES = Object.values(I18N_LANGUAGE_ALIASES)
	.flat()
	// this allows for no translation in storybook
	.concat(['none']);

export const DEFAULT_I18N_LOCALE = I18nSupportedLocale.ENGLISH;
